module.exports = __webpack_public_path__ + "img/hw-s4.4e2e4765.svg";